import type { LucideIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger
} from '@/components/ui/tooltip';

interface IconButtonWithBadgeProps {
    icon: LucideIcon;
    count?: number;
    title: string;
    active?: boolean;
    onClick?: () => void;
}

export function IconButtonWithBadge({
    icon: Icon,
    count,
    title,
    active,
    onClick
}: IconButtonWithBadgeProps) {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <div className="relative">
                    {count !== undefined && count > 0 && (
                        <div className="top-[-8px] left-[-8px] z-10 absolute flex justify-center items-center bg-background shadow-xs px-2.5 py-2.5 border border-border rounded-full w-6 h-6">
                            <span className="font-semibold text-foreground-secondary text-sm leading-4">
                                {count}
                            </span>
                        </div>
                    )}
                    <Button pill
                        variant="tertiary"
                        active={active}
                        size="icon"
                        className="bg-background w-10 h-10"
                        onClick={onClick}
                    >
                        <Icon
                            className="text-secondary-foreground"
                            strokeWidth={1.5}
                        />
                    </Button>
                </div>
            </TooltipTrigger>
            <TooltipContent side="left">
                <p>{title}</p>
            </TooltipContent>
        </Tooltip>
    );
}
